const airport = {
    getlist: 'airport/getlist',
    add: 'airport/add',
    update: 'airport/update',
    remove: 'airport/remove',
    get: 'airport/get',
    getall: 'airport/getall',
    clearcache: 'airport/clear-cache',
}
export default airport
